/* eslint-disable @typescript-eslint/no-explicit-any */

import UniversalCookie from "universal-cookie"

const Cookie = new UniversalCookie()

export interface CookieGetOptions {
  doNotParse?: boolean
  doNotUpdate?: boolean
}

export interface CookieSetOptions {
  path?: string
  expires?: Date
  maxAge?: number
  domain?: string
  secure?: boolean
  httpOnly?: boolean
  sameSite?: boolean | "none" | "lax" | "strict"
  partitioned?: boolean
}

export interface CookieChangeOptions {
  name: string
  value?: any
  options?: CookieSetOptions
}

export class CookieServiceClass {
  set(name: string, value: any, options?: CookieSetOptions) {
    Cookie.set(name, value, options)
  }

  get(name: string, options?: CookieGetOptions): any {
    return Cookie.get(name, options)
  }

  remove(name: string) {
    Cookie.remove(name)
  }
}

export const CookieService = new CookieServiceClass()
